export default "__VITE_ASSET__CiN9J$G4__"